<div class="main">
	<button
		style="padding: 0.4rem; margin: 3px"
		(click)="goBack()"
		nbButton
		status="primary"
		class="mr-4"
		type="button"
	>
		<nb-icon icon="arrow-back-outline"></nb-icon>
	</button>
</div>
